"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("g", {
      clipPath: "url(#clip0_20701_985)",
      children: (0, jsx_runtime_1.jsx)("path", {
        d: "M17.2679 15.1699L21.2523 15.1699C22.12 15.1699 22.8234 14.6084 22.8234 13.9158L22.8235 5.1374C22.8235 4.4448 22.12 3.88334 21.2523 3.88334L7.11172 3.88336C6.24399 3.88336 5.54055 4.44483 5.54055 5.13743L5.54043 5.72602C5.54033 6.19473 5.2147 6.60048 4.75713 6.70205L2.05428 7.30203C1.69564 7.3689 1.42498 7.66571 1.39139 8.02898C1.06344 11.5758 2.28988 14.4177 4.57381 17.0167C7.1039 19.8958 10.2401 21.7548 14.7045 21.3421C15.0678 21.3085 15.3646 21.0379 15.4315 20.6792L15.8961 18.1873C15.9776 17.7501 15.7605 17.3116 15.3634 17.1112L12.2294 15.5302C11.7591 15.2929 11.1854 15.4612 10.9178 15.9148L10.2676 17.0167L9.68215 16.7543C8.03518 16.016 6.71712 14.6979 5.97883 13.0509L5.71639 12.4655L6.8256 11.8C7.27079 11.5329 7.43752 10.9695 7.20941 10.5031L6.77475 9.61444M8.68343 7.58683L14.1825 11.349L19.6816 7.58683",
        stroke: "currentColor",
        strokeWidth: "1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    }), (0, jsx_runtime_1.jsx)("defs", {
      children: (0, jsx_runtime_1.jsx)("clipPath", {
        id: "clip0_20701_985",
        children: (0, jsx_runtime_1.jsx)("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      })
    })]
  });
};

exports.default = Icon;